import React from 'react'

interface LineItem {
  id?: number
  variant_id?: number
  product_name?: string
  variant_name?: string
  variant_sku?: string
  quantity: number | null
  product_format?: string | null
}

interface LineItemDisplayProps {
  item: LineItem
}

export function LineItemDisplay({ item }: LineItemDisplayProps) {
  return (
    <div className="p-3 bg-gray-50 rounded mb-2">
      <div className="font-bold mb-1">
        {item.product_name && item.variant_name ? (
          <>
            {item.product_name} - {item.variant_name}
          </>
        ) : (
          <>Product Variant ID: {item.variant_id}</>
        )}
      </div>
      {item.variant_sku && (
        <div className="text-gray-500 text-sm">SKU: {item.variant_sku}</div>
      )}
      <div className="mt-1">
        Quantity: {item.quantity ?? '-'}
        {item.product_format && ` (${item.product_format})`}
      </div>
    </div>
  )
}
